import { useEffect } from 'react';

import type { ChartExportInfo } from './chart-menu/chart-export-types';
import { usePageExport } from './chart-menu/PageExportProvider';

type GaugeExportMetaProps = {
  chartId: string;
  enabled: boolean;
  gaugeMainText: string;
  gaugeValue: number;
  gaugeEntities?: ChartExportInfo['gaugeEntities'];
  gaugeColors?: string[];
  gaugeMinLabel?: string;
  gaugeMaxLabel?: string;
};

export const GaugeExportMeta = ({
  chartId,
  enabled,
  gaugeMainText,
  gaugeValue,
  gaugeEntities,
  gaugeColors,
  gaugeMinLabel,
  gaugeMaxLabel,
}: GaugeExportMetaProps) => {
  const { updateChartExportInfo, clearChartExportInfo } = usePageExport();
  const serializedEntities = JSON.stringify(gaugeEntities ?? null);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const entities = JSON.parse(
      serializedEntities
    ) as ChartExportInfo['gaugeEntities'];
    updateChartExportInfo(chartId, {
      gaugeMainText,
      gaugeValue,
      gaugeEntities: entities ?? undefined,
      gaugeColors,
      gaugeMinLabel,
      gaugeMaxLabel,
    });
    const removedFields = (
      [
        'gaugeEntities',
        'gaugeColors',
        'gaugeMinLabel',
        'gaugeMaxLabel',
      ] as const
    ).filter(
      (field) =>
        ({
          gaugeEntities: entities ?? undefined,
          gaugeColors,
          gaugeMinLabel,
          gaugeMaxLabel,
        })[field] === undefined
    );
    if (removedFields.length > 0) {
      clearChartExportInfo(chartId, removedFields);
    }
  }, [
    chartId,
    enabled,
    gaugeMainText,
    gaugeValue,
    serializedEntities,
    gaugeColors,
    gaugeMinLabel,
    gaugeMaxLabel,
    updateChartExportInfo,
    clearChartExportInfo,
  ]);

  return null;
};
